import { render } from "./CropArea.vue?vue&type=template&id=32d3959f&scoped=true&ts=true"
import script from "./CropArea.vue?vue&type=script&lang=ts"
export * from "./CropArea.vue?vue&type=script&lang=ts"

import "./CropArea.vue?vue&type=style&index=0&id=32d3959f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d3959f"]])

export default __exports__